<div class="cardLayout">
  <!-- <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">Employees given promotion ({{totalCount}})</p>
         </div>
         <div class="popup-close">
          <button class="download-btn" (click)="exportToExcel()">
            <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
            Download
          </button>
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
 
    </ion-col>
  </ion-row> -->

  <ion-col size="12" size-md="3">
    <div class="promo-header-row">
      
      <!-- LEFT SIDE -->
      <p class="fs-16 fs_14ForMobile font_regular">
        Employees given promotion ({{totalCount}})
      </p>
  
      <!-- RIGHT SIDE -->
      <div class="promo-header-actions">
        <!-- Refresh Icon -->
        <span 
        class="ml-5 mt-10 fs-20 material-icons btn-reset"
        style="cursor:pointer;"
        [class.clicked]="isClicked"
        (click)="resetGrid(); isClicked = true"
        (animationend)="isClicked = false">
        refresh
      </span>
      
      <span 
        class="ml-5 mt-10 fs-20 material-icons icon-download"
        style="cursor:pointer;"
        (click)="onBtExport()">
        download
      </span>
      
  
        <span 
          [mat-dialog-close] 
          class="ml-35 mr-5 fs-30 material-icons popup-close-icon"
          style="cursor:pointer;">
          close
        </span>
      </div>
  
    </div>
  </ion-col>
  

  <ion-row>
    <ion-col size="12">
      <div class="table-container">
      <!-- <table class="Market-correction-employees-table">
        <thead>
          <tr>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Department
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Band 
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Employee
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Manager
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                HOD
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                DOJ
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Promotion
              </div>
            </th>
            <th class="fs-14 fs_12ForMobile font_bold cl-black">
              <div class="icon-style">
                Promotion %
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let department of getEmpGivenPromotionData">
            <ng-container *ngFor="let band of department.bandGrades; let i = index">
              <ng-container *ngFor="let employee of band.employeeData; let j = index">
                <tr>
                  <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                    {{department.departmentName}}
                  </td>
                  <td *ngIf="j === 0" [attr.rowspan]="band.employeeData.length">
                    {{ band.band }}
                  </td>
                  <td>{{employee.employeeName}}</td>
                  <td>{{employee.managerName}}</td>
                  <td>{{employee.hodName}}</td>
                  <td>{{employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                  <td>{{employee?.isPromoted ? 'Yes': 'No'}}</td>
                  <td>{{employee.promotionPercentage | number}}</td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
       </tbody>
       <tfoot>
        <tr>
          <td colspan="7" class="total">Total</td>
          <td class="total">{{promotionPercentageTotal | number}}</td>
        </tr>
       </tfoot>
      </table> -->
      <ag-grid-angular
      class="ag-theme-alpine Market-correction-employees-grid"
      style="width: 100%; height: 300px;"
      [rowData]="promotionRowData"
      [columnDefs]="promotionColumnDefs"
      [defaultColDef]="defaultColDef"
      [pinnedBottomRowData]="pinnedBottomRowData"
      [suppressMovableColumns]="true"
      [pagination]="true"
      [paginationPageSize]="20"
      (gridReady)="onPromotionGridReady($event)">
    </ag-grid-angular>
      
    </div>
    </ion-col>
  </ion-row>
</div>